import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function NewsroomLoadingState() {
  const { t } = useTranslation('regulatory-alerts')

  return (
    <div className='flex items-center gap-2 text-muted-foreground'>
      <Loader2 className='size-4 animate-spin' />
      {t('inbox.loading')}
    </div>
  )
}
